import m from 'mithril'

export default m.trust(`
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
	<rect x="5" y="1" width="6" height="14" rx="3" fill="white" fill-opacity="0.6"/>
	<rect x="4.6" y="0.6" width="6.8" height="14.8" rx="3.4" stroke="white" stroke-opacity="0.6" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
	<circle cx="8" cy="4" r="1" fill="#010517" stroke="#010517" stroke-linejoin="round"/>
	<circle cx="8" cy="8" r="1" fill="#010517" stroke="#010517" stroke-linejoin="round"/>
	<circle cx="8" cy="12" r="1" fill="#010517" stroke="#010517" stroke-linejoin="round"/>
</svg>
`)
